export function toTitleCase(str) {
    let lowerCase = str.toLowerCase()
    let toTitleCase = lowerCase.split(' ').map((s) => s==='url'?s.toUpperCase():s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
    return toTitleCase;
}

export const truncateString = (string = '', maxLength = 85) =>
    string.length > maxLength
        ? `${string.substring(0, maxLength)}…`
        : string


export function capitalize_sentence(string) {
    const sentences = string.split(". ")
    const capitalizeSentences = []
    for(const sentence of sentences){
        const capitalizeSentence=sentence[0].toUpperCase()+sentence.slice(1)
        capitalizeSentences.push(capitalizeSentence)
    }

    return capitalizeSentences.join(". ")
    
}

export function validateEmail(email) {
        let blockedRegex = [
            /[a-z0-9]+@[a-z]+\.edu\.[a-z]{2,3}/i,
            /^[a-z0-9](\.?[a-z0-9]){5,}@g(oogle)?mail\.com$/i,
            /^[a-z0-9._%+-]+@gmail\.com$/i,
            /^[a-z0-9._%+-]+@yahoo\.com$/i,
            /^[a-z0-9._%+-]+@outlook\.com$/i,
            /^[a-z0-9._%+-]+@aol\.com$/i,
            /^[a-z0-9._%+-]+@hotmail\.com$/i,
            /^[a-z0-9._%+-]+@icloud\.com$/i,
            /^[a-z0-9._%+-]+@msn\.com$/i,

            /^[a-z0-9._%+-]+@pymetrics\.ai$/i,
            /^[a-z0-9._%+-]+@harver\.com$/i,
            /^[a-z0-9._%+-]+@shl\.com$/i,
            /^[a-z0-9._%+-]+@hirevue\.com$/i,
            /^[a-z0-9._%+-]+@criteriacorp\.com$/i,
            /^[a-z0-9._%+-]+@knackconsulting\.com$/i,
            /^[a-z0-9._%+-]+@hoganassessments\.com$/i,
            /^[a-z0-9._%+-]+@testgorilla\.com$/i,
            /^[a-z0-9._%+-]+@hipeople\.io$/i,
            /^[a-z0-9._%+-]+@sovaassessment\.com$/i,
            /^[a-z0-9._%+-]+@x0pa\.com$/i,
            /^[a-z0-9._%+-]+@ascendconsulting\.me$/i,
            /^[a-z0-9._%+-]+@mercer\.com$/i,
            /^[a-z0-9._%+-]+@mettl\.com$/i,
            /^[a-z0-9._%+-]+@talview\.com$/i,
            /^[a-z0-9._%+-]+@pulsifi\.me$/i,
            /^[a-z0-9._%+-]+@recruitee\.com$/i,
            /^[a-z0-9._%+-]+@icims\.com$/i,
            /^[a-z0-9._%+-]+@jazzhr\.com$/i,
            /^[a-z0-9._%+-]+@gartner\.com$/i,
            /^[a-z0-9._%+-]+@cegid\.com$/i,
            /^[a-z0-9._%+-]+@talentq\.net$/i,
            /^[a-z0-9._%+-]+@savilleassessment\.com$/i,
            /^[a-z0-9._%+-]+@thomas\.co$/i,
            /^[a-z0-9._%+-]+@predictiveindex\.com$/i,
            /^[a-z0-9._%+-]+@practicetests.cubiks\.com$/i,
            /^[a-z0-9._%+-]+@ddiworld\.com$/i,
            /^[a-z0-9._%+-]+@calipercorp\.com$/i,
            /^[a-z0-9._%+-]+@predictivesuccess\.com$/i,
            /^[a-z0-9._%+-]+@cappfinity\.com$/i,
            /^[a-z0-9._%+-]+@insightassessment\.com$/i,
            /^[a-z0-9._%+-]+@cegid\.com$/i,
            /^[a-z0-9._%+-]+@talentq\.net$/i,
            /^[a-z0-9._%+-]+@savilleassessment\.com$/i,
            /^[a-z0-9._%+-]+@thomas\.co$/i,
            /^[a-z0-9._%+-]+@predictiveindex\.com$/i,
            /^[a-z0-9._%+-]+@practicetests.cubiks\.com$/i,
            /^[a-z0-9._%+-]+@ddiworld\.com$/i,
            /^[a-z0-9._%+-]+@calipercorp\.com$/i,
            /^[a-z0-9._%+-]+@predictivesuccess\.com$/i,
            /^[a-z0-9._%+-]+@cappfinity\.com$/i,
            /^[a-z0-9._%+-]+@insightassessment\.com$/i,
            /^[a-z0-9._%+-]+@[a-z0-9.-]+.edu.[a-z]{2,}$/i,
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.edu$/i
            // /^[a-z0-9._%+-]+@[a-z0-9.-]+\.edu\.[a-z]{2,}$/i


        ];
        for (let i = 0; i < blockedRegex.length; i++) {
            let regex = blockedRegex[i]; // console.log("regex: ", regex);
            let status = regex.test(email)
            if (status) {
             
                return "Please use a valid work email";
            }
        }
        return true;
    }
